import { About, Home, Portfolio } from "pages";
import React from "react";
import { Route, Routes } from "react-router-dom";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/portfolio/:id" element={<Portfolio />} />
    </Routes>
  );
};

export default AppRoutes;
